import React, { Fragment, SetStateAction, Dispatch, useState, useMemo } from 'react';
import { Drawer } from "@/components";
import { Shop } from "@/sunzi";
import { i18n } from "@/utils";
import { IncrementType } from '.';
import Icon from './icon';
import { ProductIncrement } from './mini-me';
import styles from './style.less';
import classnames from "classnames";

/** 按钮规则类型 */
type ButtonType = {
  [type: string]: {
    text: string,
    funcType: IncrementType,
    price?: number,
    isInput?: boolean,
    isOr?: boolean,
  }[]
}

interface IncrementDrawerProps {
  /** 商铺信息 */
  shop: Shop;
  /** 加价 type */
  type: keyof ProductIncrement;
  /** 图片展示 */
  image: string;
  /** 是否只有刻字 */
  isOnlyText?: boolean;
  /** 加价 */
  productIncrement: ProductIncrement;
  /** 增值服务函数 */
  handleIncrement: (type: IncrementType) => void;
  /** 设置增值服务状态 */
  setIncrementType: (type: IncrementType) => void;
  /** 设置加价价格 */
  setAddedPrice: Dispatch<SetStateAction<number>>;
  /** 设置 zuploader组件 显影 */
  setZuploaderVisible: Dispatch<SetStateAction<boolean>>;
  /** 关闭回调 */
  onClose: () => void;
}

const IncrementDrawer: React.FC<IncrementDrawerProps> = ({
  shop,
  type,
  image,
  isOnlyText,
  productIncrement,
  handleIncrement,
  setIncrementType,
  setAddedPrice,
  setZuploaderVisible,
  onClose,
}) => {

  const buttonType: ButtonType = useMemo(() => {
    const type = {
      // 普通的按钮
      normal: [
        {
          text: i18n.format('modules.mini.me.double.side.print'),
          price: productIncrement.normal.price,
          // func: handleSameSide,
          funcType: IncrementType.DoubleSide,
        },
        {
          text: i18n.format('modules.mini.me.one.side.only.print'),
          // func: handleSkipAddCart,
          funcType: IncrementType.SameSide,
        },
      ],
      // 连体帽的按钮
      hood: [
        {
          text: i18n.format('modules.mini.me.add.photo.back.side'),
          price: productIncrement.hood.price,
          // func: handleAddSideImage,
          funcType: IncrementType.NewImageSide,
          isInput: true,
        },
        {
          text: i18n.format('modules.mini.me.one.side.print'),
          // func: handleSkipAddCart,
          funcType: IncrementType.SameSide,
        },
      ],
      // 刻字的按钮
      lineText: [
        {
          text: i18n.format('modules.mini.me.add.photo.back.side'),
          price: productIncrement.hood.price,
          // func: handleAddSideImage,
          funcType: IncrementType.NewImageSide,
          isInput: true,
        },
        {
          text: i18n.format('modules.mini.me.add.text.back.side'),
          price: productIncrement.lineText.price,
          // func: handleAddText,
          funcType: IncrementType.LineText,
        },
        {
          isOr: true,
          text: i18n.format('modules.mini.me.one.side.only.print'),
          // func: handleSkipAddCart,
          funcType: IncrementType.SameSide,
        },
      ],
    }
    if (isOnlyText) {
      type.lineText.shift();
    }
    return type;
  }, []);

  /** 当前选中的选项 */
  const [ buttonSelected, setButtonSelected ] = useState<number>(0);

  /** 点击确认 */
  const handleConfirm = () => {
    const funcType = buttonType[type][buttonSelected].funcType;
    if (funcType !== IncrementType.NewImageSide) {
      setAddedPrice((buttonType[type][buttonSelected].price ?? 0));
      setIncrementType(funcType);
      handleIncrement(funcType);
    } else {
      setIncrementType(funcType);
      setZuploaderVisible(true);
    }
  }

  return (
    <div className={styles.incrementDrawer}>
      <Drawer
        onClose={onClose}
        mask
      >
        <div className={styles.incrementDrawerContent}>
          <div className={styles.image}>
            <img src={image} />
          </div>
          <div className={styles.close} onClick={onClose}>
            <Icon type="close" color="#000" size={30} />
          </div>
          <div className={styles.title}>{i18n.format('modules.mini.me.print.customization')}</div>
          <div className={styles.buttonLayout}>
            {buttonType[type].map((item, index) => (
              <Fragment key={index}>
                {item.isOr &&
                  <div className={styles.divider}>
                    <span className={styles.dividerText}>{i18n.format('modules.mini.me.or')}</span>
                  </div>
                }
                <div
                  className={classnames(styles.button, {
                    [styles.selected]: index === buttonSelected,
                    [styles.lineTextLayout]: type === 'lineText' && !item.isOr,
                  })}
                  onClick={() => setButtonSelected(index)}
                >
                  <span className={styles.text}>{item.text}</span>
                  {item.price &&
                    <div className={styles.price}>
                      {shop.language === 'jp' ?
                        `+${item.price}${shop.currencySymbol}` :
                        `+${shop.currencySymbol}${item.price.toFixed(2)}`
                      }
                    </div>
                  }
                  {index === buttonSelected &&
                    <Icon className={styles.selectedIcon} type="tick-circle" color="#ff533a" size={18} />
                  }
                </div>
              </Fragment>
            ))}
          </div>
          <div className={styles.confirm} onClick={handleConfirm}>
            {type === 'normal' ? i18n.format('modules.global.add.cart') : i18n.format('modules.global.continue')}
          </div>
        </div>
      </Drawer>
    </div>
  )
}

export default IncrementDrawer;
